import client from "@/api/client"
import {
  computeIsAdminHere,
  MyWorkspaceMembership,
  WorkspaceBranding,
} from "@/utils/workspaceMemberships"
import { useSession } from "next-auth/react"
import React, { ReactNode, useEffect, useState } from "react"

export const WorkspaceContext = React.createContext<{
  current: WorkspaceBranding | undefined
  setCurrent: (data: WorkspaceBranding) => void
  myWorkspaces: MyWorkspaceMembership[]
  myWorkspacesLoaded: boolean
  isAdminHere: boolean
}>(null!)

export const WorkspaceProvider = ({
  children,
  initialCurrent,
}: {
  children: ReactNode
  initialCurrent?: WorkspaceBranding | null
}) => {
  const { data: session } = useSession()
  const [current, setCurrent] = useState<WorkspaceBranding | undefined>(
    initialCurrent ?? undefined
  )
  const [myWorkspaces, setMyWorkspaces] = useState<MyWorkspaceMembership[]>([])
  const [myWorkspacesLoaded, setMyWorkspacesLoaded] = useState(false)

  useEffect(() => {
    if (initialCurrent) {
      return
    }

    client.instance
      .get<WorkspaceBranding>("/workspaces/current")
      .then((response) => setCurrent(response.data))
      // eslint-disable-next-line no-console
      .catch((error) => console.error(error))
  }, [initialCurrent])

  useEffect(() => {
    if (!session) {
      setMyWorkspaces([])
      setMyWorkspacesLoaded(true)
      return
    }
    client.instance
      .get<MyWorkspaceMembership[]>("/workspace-memberships/mine")
      .then((response) => setMyWorkspaces(response.data))
      // eslint-disable-next-line no-console
      .catch((error) => console.error(error))
      .finally(() => setMyWorkspacesLoaded(true))
  }, [session])

  return (
    <WorkspaceContext.Provider
      value={{
        current,
        setCurrent,
        myWorkspaces,
        myWorkspacesLoaded,
        isAdminHere: computeIsAdminHere(myWorkspaces, current?.subdomain),
      }}
    >
      {children}
    </WorkspaceContext.Provider>
  )
}

export default WorkspaceProvider
